import {Card, Row, Col, Space} from "antd";
import Button from "@mui/material/Button";

import StockChart from "../../charts/StockChart";

import {createFutureDateRange} from "../../utils/datetime";
import {stringMixin, money} from "../../utils/strings";


const prepareMeanPathForChart = (meanPath)=>{
    const dates = createFutureDateRange(meanPath.length);
    return meanPath.map((value, index)=>[dates[index], value]);
}


const JourneySimulation = ({simulation})=>{
    const config = simulation.config
    const [initialValue, targetReturn, targetRisk, numYears, numStepsPerYear] = [
        config.initial_value, config.target_annual_return, config.target_annual_volatility,
        config.num_years, config.time_steps_per_year
    ];
    const [trueReturn, trueRisk] = [simulation.mean_return, simulation.volatility];
    const chartData = prepareMeanPathForChart(simulation.mean_path);


    return (
        <Card>
            <Space>
                {money(initialValue)} invested with annual return {trueReturn.toFixed(2)}% and annual volatility {trueRisk.toFixed(2)}%
            </Space>
            <div style={{height: 400, width: '100%'}}>
                <StockChart
                    dataSeries={[
                        {
                            plot: 0,
                            data: [
                                {name: "Mean Path", data: chartData, type: "line", color: "#0000ff"},
                            ]
                        }
                    ]}
                    showRangeSelector={false}
                />
            </div>
        </Card>
    )
}


export default JourneySimulation;